// Cursor
const c = document.getElementById('c'), cr = document.getElementById('cr');
let mx=0,my=0,rx=0,ry=0;
document.addEventListener('mousemove', e => { mx=e.clientX; my=e.clientY; c.style.left=mx+'px'; c.style.top=my+'px'; });
(function loop(){ rx+=(mx-rx)*.1; ry+=(my-ry)*.1; cr.style.left=rx+'px'; cr.style.top=ry+'px'; requestAnimationFrame(loop); })();
document.querySelectorAll('a,button,input,textarea,.cg,.product-card').forEach(el=>{
  el.addEventListener('mouseenter',()=>document.body.classList.add('hov'));
  el.addEventListener('mouseleave',()=>document.body.classList.remove('hov'));
});

// Scroll reveal
const io = new IntersectionObserver(es=>es.forEach(e=>{ if(e.isIntersecting) e.target.classList.add('in'); }),{threshold:.08});
document.querySelectorAll('.reveal,.ti').forEach(el=>io.observe(el));

// Product gallery thumbnails
document.querySelectorAll('.product-thumb').forEach(thumb=>{
  thumb.addEventListener('click',()=>{
    const src = thumb.querySelector('img').src;
    const mainImg = thumb.closest('.product-gallery').querySelector('.product-main-img img');
    if(mainImg) mainImg.src = src;
    thumb.closest('.product-thumbs').querySelectorAll('.product-thumb').forEach(t=>t.classList.remove('active'));
    thumb.classList.add('active');
  });
});

// Variant selection
document.querySelectorAll('.variant-btn').forEach(btn=>{
  btn.addEventListener('click',()=>{
    if(btn.classList.contains('sold-out')) return;
    const group = btn.closest('.variant-options');
    group.querySelectorAll('.variant-btn').forEach(b=>b.classList.remove('active'));
    btn.classList.add('active');
    const variantId = btn.dataset.variantId;
    const input = document.querySelector('input[name="id"]');
    if(input && variantId) input.value = variantId;
  });
});

// Smooth scroll
document.querySelectorAll('a[href^="#"]').forEach(a=>{
  a.addEventListener('click',e=>{
    const t=document.querySelector(a.getAttribute('href'));
    if(t){e.preventDefault();t.scrollIntoView({behavior:'smooth'});}
  });
});
